import type { NodeType, Schema } from '@atlaskit/editor-prosemirror/model';

export const isTableNode = ({
	nodeType,
	schema,
}: {
	nodeType: NodeType;
	schema: Schema;
}): boolean => {
	const { table, tableRow, tableHeader, tableCell } = schema.nodes;
	return [table, tableRow, tableHeader, tableCell].includes(nodeType);
};
